import { EPaymentProvider } from '../../../types/redux/paymentMethods';
import { loadPaymentProviderScript } from '../loadPaymentProviderScript';
import { ITelemetryLogger } from '@cian/telemetry/shared';

interface IParams {
  paymentProviders: Array<EPaymentProvider>;
  telemetry: ITelemetryLogger;
}

export const loadPaymentProvidersScripts = async (params: IParams): Promise<void> => {
  const { paymentProviders, telemetry } = params;

  try {
    await Promise.all(paymentProviders.map(loadPaymentProviderScript({ telemetry })));
  } catch {
    // do nothing
  }

  return Promise.resolve();
};
